import React from 'react';
import { services, servicesBridgeSentence } from '../mock';
import { Lightbulb, Video, Calendar, Megaphone } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const iconMap = {
  'Content Strategy': Lightbulb,
  'Creative Production': Video,
  'Event Direction': Calendar,
  'Brand Storytelling': Megaphone
};

const colors = [
  { bg: 'from-midnight-blue to-midnight-blue/80', icon: 'text-white' },
  { bg: 'from-whale-blue to-whale-blue/82', icon: 'text-white' },
  { bg: 'from-midnight-blue to-midnight-blue/80', icon: 'text-white' },
  { bg: 'from-whale-blue to-whale-blue/82', icon: 'text-white' }
];

const Services = () => {
  return (
    <section id="services" className="py-12 md:py-16 bg-midnight-blue relative overflow-hidden">
      {/* Pattern backdrop — same as hero */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage: 'url(/hero-pattern.png)',
          backgroundRepeat: 'repeat',
          backgroundSize: '760px auto',
          backgroundPosition: 'top left',
        }}
        data-testid="services-pattern-backdrop"
      />

      <div className="container mx-auto px-8 md:px-16 relative z-10">
        <div className="max-w-7xl mx-auto">
          {/* Section header — small bold centered label */}
          <div className="text-center mb-8">
            <h2 className="text-[20px] tracking-[0.2em] uppercase text-white font-montserrat font-bold">
              Services
            </h2>
          </div>

          {/* Colorful service grid */}
          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const Icon = iconMap[service.title] || Lightbulb;
              const color = colors[index];
              return (
                <Card
                  key={index}
                  className="group border-none shadow-xl hover:shadow-2xl transition-all duration-300 overflow-hidden rounded-sm"
                >
                  <CardContent className="py-6 px-8">
                    {/* Number label */}
                    <div className="min-h-12 md:h-12 mb-3 flex items-start">
                      <span
                        className="font-playfair font-bold text-5xl leading-none"
                        style={{
                          color: '#872D37',
                          letterSpacing: '-0.05em'
                        }}
                      >
                        0{index + 1}
                      </span>
                    </div>

                    {/* Title — auto height on mobile, fixed on desktop for row alignment */}
                    <div className="min-h-12 md:h-12 mb-4 flex items-start">
                      <h3 className="font-playfair font-bold text-2xl text-charcoal leading-tight group-hover:text-midnight-blue transition-colors">
                        {service.title}
                      </h3>
                    </div>

                    {/* Subtitle — auto height on mobile, fixed on desktop for row alignment */}
                    <div className="min-h-10 md:h-10 mb-3 flex items-start">
                      {service.subtitle && (
                        <p className="text-sm text-whale-blue font-medium italic leading-relaxed">
                          {service.subtitle}
                        </p>
                      )}
                    </div>

                    {/* Divider line - now perfectly aligned */}
                    <div className="h-px bg-gradient-to-r from-whale-blue/32 via-whale-blue/52 to-whale-blue/32 mb-3"></div>
                    
                    {service.bullets && (
                      <ul className="space-y-1.5">
                        {service.bullets.map((bullet, idx) => (
                          <li key={idx} className="text-sm text-charcoal/80 leading-relaxed flex items-start gap-2">
                            <span className="text-whale-blue mt-0.5 text-xs">•</span>
                            <span>{bullet}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;